import { render, staticRenderFns } from "./DashBoardVirtualAccountsView.vue?vue&type=template&id=40343938&scoped=true&"
import script from "./DashBoardVirtualAccountsView.vue?vue&type=script&lang=js&"
export * from "./DashBoardVirtualAccountsView.vue?vue&type=script&lang=js&"
import style0 from "./DashBoardVirtualAccountsView.vue?vue&type=style&index=0&id=40343938&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40343938",
  null
  
)

export default component.exports